import GeoJSON from "ol/format/GeoJSON.js";
import { createEmpty, extend } from "ol/extent";
import apiClient from "../Api";

// Objeto con los valores por defecto
const defaultPreliminarBody = {
  ine_code: "",
  n_ref_catastral: "",
  status: "",
  // "building_creation_date": "",
  current_use: "",
  owner: "",
  address: "",
  link_maps: null,
  link_catastro: null,
  inspection_type: "",
  element_type: "",
  asbestos_type: "",
  description: "",
  withdrawal_priority: "",
  uds_amianto: 0,
  m_amianto: 0,
  m2_amianto: 0,
  m3_amianto: 0,
  has_lab_measures: false,
  lab_measure_ref_code: "",
  lab_measure_note: "",
  withdrawal_cost: 0,
  building_age: 0,
  m2_catastro: 0,
  risk_simplify_type: "",
  // "building_refurbishing_date": "2025-02-20",
  province: "",
  municipality: "",
  risk_simplify_type: "",
  risk_final_value: "",
  risk_form_value: "",
  risk_type_used: "",
  is_asbestos: null,
  made_by: "Agforest S.L.",
  risk_form_level_accesibility: 0,
  risk_form_key_accesibility: "",
  risk_form_level_quantity: 0,
  risk_form_key_quantify: "",
  risk_form_level_number_exposed: 0,
  risk_form_key_number_exposed: "",
  risk_form_level_location: 0,
  risk_form_key_location: "",
  risk_form_level_material_status: 0,
  risk_form_key_material_status: "",
  risk_form_level_variery: 0,
  risk_form_key_variery: "",
  risk_form_level_technical_accesibility: 0,
  risk_form_key_technical_accesibility: "",
  risk_form_level_fiability: 0,
  risk_form_key_fiability: "",
  geometry: {},
};

/**
 * Envía una petición POST usando axios.
 *
 * @param {string} url - La URL a la que se enviará la petición.
 * @param {object} customData - Objeto con los campos que se desean reemplazar en el cuerpo por defecto.
 * @returns {Promise<object>} - La respuesta del servidor.
 */
async function create_preliminar_element(layer_uuid, customData = {}) {
  // Combina el objeto por defecto con los datos personalizados.
  // Los valores en customData sobrescribirán los del defaultBody si existen.
  let payload = { ...defaultPreliminarBody, ...customData };

  payload = {
    ...payload,
    ...(payload?.building_creation_date && {
      building_creation_date: payload.building_creation_date.replace(/Z$/, ""),
    }),
    ...(payload?.building_refurbishing_date && {
      building_refurbishing_date: payload.building_refurbishing_date.replace(
        /Z$/,
        ""
      ),
    }),
  };

  try {
    const response = await apiClient.post(
      "/layers/asbestos/create/AMIANTO_CENSO/" + layer_uuid,
      payload
    );
    // console.log("Respuesta del servidor:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error en la petición POST:", error);
    throw error;
  }
}

async function update_preliminar_element(item_uuid, layer_uuid, payload = {}) {
  try {
    const response = await apiClient.put(
      `/layers/asbestos/update/AMIANTO_CENSO/${layer_uuid}/${item_uuid}`,
      payload
    );
    // console.log("Respuesta del servidor:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error en la petición PUT:", error);
    throw error;
  }
}

async function delete_preliminar_element(item_uuid, layer_uuid) {
  try {
    const response = await apiClient.delete(
      `/layers/asbestos/delete/AMIANTO_CENSO/${layer_uuid}/${item_uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Error en la petición DELETE:", error);
    throw error;
  }
}

export {
  create_preliminar_element,
  update_preliminar_element,
  delete_preliminar_element,
};
